<template>
    <section class="content">
      <div class="row">
        <div class="col-md-12">
          <div class="box">
            <div class="box-header">
              <h3 class="box-title">Collection Records</h3>
            </div>
  
            <div class="box-body no-padding">
              <!-- <table class="table table-condensed">
                <tbody>
                    <tr>
                    <th style="width: 10px">#</th>
                    <th>ApplicationNo : {{ singleLoanMemberLoanPlan.applicationNo }}</th>
                    <th>Total Amount : {{ singleLoanMemberLoanPlan.totalAmt}}</th>
                    </tr>
                    <tr>
                    <td>1.</td>
                    <td>Disbursement Date</td>
                    <td>{{ singleLoanDisbursement.disbursementDate | myDate }}</td>
                    </tr>
                    <tr>
                    <td>2.</td>
                    <td>First EMI Date</td>
                    <td>{{ singleLoanDisbursement.emiStartDate | myDate }}</td>
                    </tr>
                    <tr>
                    <td>3.</td>
                    <td>Last EMI Date</td>
                    <td>{{ singleLoanDisbursement.emiEndDate | myDate }}</td>
                    </tr>
                    <tr>
                    <td>4.</td>
                    <td>Amount</td>
                    <td>{{ singleLoanDisbursementPlan.amount }}</td>
                    </tr>
                    <tr>
                    <td>5.</td>
                    <td>EMI</td>
                    <td>{{ singleLoanDisbursementPlan.emi }}</td>
                    </tr>
                    <tr>
                    <td>6.</td>
                    <td>File Charge</td>
                    <td>{{ singleLoanDisbursementPlan.fileCharge }}</td>
                    </tr>
                    <tr>
                    <td>7.</td>
                    <td>Processing Fee</td>
                    <td>{{ singleLoanDisbursementPlan.processingFee }}</td>
                    </tr>
                    <tr>
                    <td>8.</td>
                    <td>Insurance Fee</td>
                    <td>{{ singleLoanDisbursementPlan.insuranceFee }}</td>
                    </tr>
                    <tr>
                    <td>9.</td>
                    <td>Rate Of Interest</td>
                    <td>{{ singleLoanDisbursementPlan.rateOfInterest }}</td>
                    </tr>
                    <tr>
                    <td>10.</td>
                    <td>Total Amount To Pay</td>
                    <td>{{ singleLoanDisbursementPlan.totalAmtToPay }}</td>
                    </tr>
                </tbody>
              </table> -->
              <table class="table table-sm table-bordered table-hover">
                <thead style="background-color: #d6dddd;">
                <tr>
                    <th class="hidden-xs">Sr.</th>
                    <th class="hidden-xs">Type</th>
                    <th>Pay Date</th>
                    <th>Amount</th>
                    <th class="hidden-xs">Received By</th>
                    <th>Mode</th>
                    <th class="hidden-xs">Status</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(row, index) in singleLoanMemberCollection" :key="index">
                    <td class="hidden-xs">{{ (index + 1) }}</td>
                    <td class="hidden-xs"><i v-if="row.type === 'panulty'">penalty</i><i v-else>{{ row.type }}</i></td>
                    <td>{{ row.paymentDate | myDate}}</td>
                    <td><strong>₹</strong>{{ row.amt }}/-</td>
                    <td class="hidden-xs"><span v-if="row.received_by">{{ row.received_by.name }}</span></td>
                    <td><span v-if="row.branch_ledger">{{ row.branch_ledger.ledger.name }}</span></td>
                    <td class="hidden-xs"><span
                        v-if="row.status == 'pending'"
                        ><i class="fa fa-exclamation-circle fa-2x text-danger" aria-hidden="true"></i></span
                        >
                        <span
                        v-if="row.status == 'paid'"
                        class="label label-success"
                        >Paid</span
                        >
                        <span
                        v-if="row.status == 'approved'"
                        ><i class="fa fa-check-circle fa-2x text-success" aria-hidden="true"></i>
                        <i v-if="row.voucher.length === 0" class="fa fa-exclamation-triangle fa-2x text-danger" title="Voucher Not Found" aria-hidden="true"></i>
                        </span
                        >
                        <span
                        v-if="row.status == 'partial'"
                        class="label label-info"
                        >Partial</span
                        >                    
                    </td>
                </tr>
                </tbody>
              </table>
            </div>
  
          </div>
        </div>
      </div>
    </section>
  </template>
  <script>
  export default {
    name: 'singleloanpaymentrecords',
    props: {
      singleLoanBranchDetail: {},
      singleLoanMemberLoanPlan: {},
      singleLoanMemberDetail: {},
      singleLoanMemberCollection: {}
    }
  }
  </script>



// WEBPACK FOOTER //
// SingleLoanPaymentRecords.vue?f088ef4c